module.exports = __webpack_public_path__ + "115a21c7ff293ca0f11f8c1dd35b6fb2.svg";